import RestaurantChapter from "@/components/RestaurantChapter";
import ClosingCTA from "@/components/ClosingCTA";

export default function Restaurants() {
  return (
    <main data-testid="restaurants-page" className="pt-16">
      <RestaurantChapter />
      <ClosingCTA />
    </main>
  );
}
